import BaseService from './baseService';

export default class SecteurActiviteService extends BaseService {
    getSecteurActivitesPaginated(lazyParams, cancelToken) {
        const queryParams = super.getQueryParams(super.getAPIPagedQuery(lazyParams))
        return this.axiosApiInstance.get(window.API_URL + `/api/SecteurActivite/getPaginated?${queryParams}`, cancelToken)
          .then(res => res.data)
          .catch(err => super.handleHttpError(err));
      }
}